import { Outlet } from 'react-router-dom';

import { PublicLayout } from 'src/layouts/setting/public-layout';
import HomePage from 'src/pages/dashboard/index';
import Error401Page from 'src/pages/401';
import Error404Page from 'src/pages/404';
import Error500Page from 'src/pages/500';
//import ContactPage from 'src/pages/contact';
import CheckoutPage from 'src/pages/checkout';

import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { componentsRoutes } from './components';
import { settingRoutes } from './setting';
import { invRoutes } from './inv';
import { dashboardRoutes } from './dashboard';
import { profileRoute } from './profile';

export const routes = [
  {
    element: (
      <PublicLayout>
        <Outlet />
      </PublicLayout>
    ),
    children: [
      {
        index: true,
        element: <HomePage />
      },
      ...componentsRoutes
    ]
  },
  ...authRoutes,
  ...authDemoRoutes,
  ...settingRoutes,
  ...invRoutes,
  ...dashboardRoutes,
  ...profileRoute,
  {
    path: 'checkout',
    element: <CheckoutPage />
  }, {
    path: '401',
    element: <Error401Page />
  },
  {
    path: '404',
    element: <Error404Page />
  },
  {
    path: '500',
    element: <Error500Page />
  },
  {
    path: '*',
    element: <Error404Page />
  }
];
